import React, { useState } from 'react'
import { UserCircleIcon } from 'components/icons'
import { useSelector } from 'react-redux'
import CustomerProfilemodal from 'components/modals/CustomerProfileModal'
import { setLoginModalOpen } from 'store/auth'
import { useDispatch } from 'react-redux'
import NotificationsPopover from 'components/popovers/NotificationsPopover'
import { getProfileImage } from 'data/helpers/users'

const UserProfileSection = () => {
  const dispatch = useDispatch()

  const [profileModalOpen, setProfileModalOpen] = useState(false)

  const { user, checked } = useSelector(state => ({
    user: state.auth.user,
    checked: state.auth.checked,
  }))

  return (
    <>
      <div className="lg:block items-center justify-center border-none cursor-pointer gap-15 text-30 whitespace-nowrap mx-15 hidden">
        {
          checked && user
            ? <div className="flex items-center gap-30" >
              <div className="pt-10">
                <NotificationsPopover />
              </div>

              <button className="flex items-center gap-15" onClick={() => setProfileModalOpen(true)}>
                <p className="uppercase text-grey text-14">{user.first_name}</p>
                {
                  getProfileImage(user)
                    ? <img src={getProfileImage(user)} className="rounded-full h-30 w-30" />
                    : <UserCircleIcon />
                }
              </button>
            </div>
            : <button className="flex items-center" onClick={() => dispatch(setLoginModalOpen(true))}>
              <p className="uppercase text-14 text-grey-800 mr-18">Login</p>
              <UserCircleIcon />
            </button>
        }
      </div>

      <CustomerProfilemodal isOpen={profileModalOpen} onClose={() => setProfileModalOpen(false)} />
    </>
  )
}

export default UserProfileSection
